export enum SectionImageType {
  IMAGE = 'image',
  PORTFOLIO = 'portfolio',
  INTERNAL = 'internal'
}
